<template>
  <el-drawer v-model="isOpenDrawer" title="消息中心" direction="rtl" :with-header="false" @close="handleClose">
    <p class="title">消息中心</p>
    <section class="tabs">
      <div
        v-for="item in tabList"
        :key="item.value"
        :class="`tab ${activeTab === item.value ? 'tab-active' : ''}`"
        @click="changeTab(item.value)"
      >
        <el-badge :value="item.count" :hidden="item.count === 0">
          <p>{{ item.label }}</p>
        </el-badge>
      </div>
    </section>
    <section class="content">
      <el-card v-for="item in tableData" :key="item.id" class="msg" @click="viewMessage(item)">
        <div v-if="item.is_read === 0" class="point"></div>
        <div class="msg-row">
          <p class="row-title">{{ item.title }}</p>
          <p class="row-time">{{ formatTime(item.created_at) }}</p>
        </div>
        <p class="text">{{ filterContent(item.content) }}</p>
      </el-card>
      <el-card v-if="tableData.length === 0"> 暂无数据 </el-card>
      <!-- 分页 -->
      <div class="pagination-wrap f">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="tablePage.current"
          :page-size="tablePage.per_page"
          layout="prev, pager, next, jumper"
          :page-count="tablePage.total_page"
        ></el-pagination>
      </div>
    </section>
    <MessageNotice ref="MessageNoticeRef" />
  </el-drawer>
</template>

<script lang="ts" setup>
import { rootStore } from '@/store/rootStore';
import { storeToRefs } from 'pinia';
import { ref, reactive, computed } from 'vue';
import request from '@/lib/request';
import apiPath from '@/lib/apiPath';
import { formatTime, BACKEND_ID } from '@/lib/utils';
import MessageNotice from './MessageNotice.vue';

const store = rootStore();

const { unreadList } = storeToRefs(store);

const isOpenDrawer = ref(false);
const initDrawer = () => {
  isOpenDrawer.value = true;
  getTableData();
};
const handleClose = () => {
  isOpenDrawer.value = false;
};

const tabMap = {
  1: '系统公告',
  2: '站内消息',
  3: '其他消息',
};
const tabList = computed(() => {
  return unreadList.value.map((item) => {
    return {
      label: tabMap[item.type],
      value: item.type,
      count: item.count,
    };
  });
});
const activeTab = ref(1);
const changeTab = (tab: string) => {
  activeTab.value = tab;
  getTableData();
};

const MessageNoticeRef = ref();
const viewMessage = async (row) => {
  const detail = await getMessageDetail(row.id);
  MessageNoticeRef.value.initModal(detail);
};

const tablePage = reactive({
  per_page: 5,
  total_page: 1,
  current: 1,
});
const tableData = ref([]);
const getTableData = () => {
  request
    .get(apiPath.notification.message, {
      type: activeTab.value,
      page: tablePage.current,
      page_size: tablePage.per_page,
      backend_id: BACKEND_ID,
    })
    .then((res) => {
      if (res) {
        tableData.value = res?.list ?? [];
        tablePage.per_page = res.paginator.page_size;
        tablePage.total_page = res.paginator.total_page;
        tablePage.current = res.paginator.current_page;
      }
    });
};
const getMessageDetail = async (id) => {
  return request.get(`${apiPath.notification.message}/${id}`).then((res) => {
    getTableData();
    getUnreadCount();
    return res;
  });
};
const getUnreadCount = () => {
  request.get(apiPath.notification.getUnreadCount, {
    backend_id: BACKEND_ID,
  }).then((res) => {
    store.setUnreadList(res);
  });
};
const searchHandler = () => {
  tablePage.current = 1;
  getTableData();
};
const handleCurrentChange = (v) => {
  tablePage.current = v;
  getTableData();
};
const filterContent = (value) => {
  const plainText = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ''); // 去掉所有标签和&nbsp;
  const filterHtml = plainText?.length > 15 ? plainText.slice(0, 15) + '...' : plainText;
  return filterHtml;
};

defineExpose({ initDrawer });
</script>

<style lang="less" scoped>
.title {
  text-align: center;
}
.tabs {
  display: flex;
  margin: 20px 0;

  .tab {
    flex: 1;
    text-align: center;
    cursor: pointer;
    p {
      margin: 0 10px;
    }
  }
  .tab-active {
    border-bottom: 2px solid #3f9eff;
  }
}
.content {
  .msg {
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
    .msg-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .row-title {
        font-size: 14px;
        font-weight: bold;
      }
      .row-time {
        color: #808080;
      }
    }
    .text {
      color: #808080;
    }
    .point {
      position: absolute;
      top: 6px;
      right: 6px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: red;
    }
  }
}
</style>
